import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React from 'react';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { RequestEntity, ISubCategoryPositionItem } from 'types';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: ISubCategoryPositionItem;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

const Item: React.FC<IItem> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const subCategoryRowClasses = classNames(style.subCategory, style.row);
	const imgWrapperClass = classNames(style.imgWrapper);
	const subCategoryNameClasses = classNames(style.subCategoryName);
	const categoryRowClasses = classNames(style.category, style.row);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);
	const isHiddenRowClasses = classNames(style.isHidden, style.row, style.list);

	const restaurants = data.restaurants.map((el) => ({
		...el,
		restaurantName: el.name,
	}));

	const isHiddenRestaurants = restaurants.filter((el) => el.isHidden);

	return (
		<div className={containerClasses}>
			<div className={subCategoryRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<div className={imgWrapperClass}>
					<ImgUploaderByEntityId
						resource={RequestEntity.SubCategories}
						entityID={data.filePath ? data.id : ''}
						photoSize="Small"
						loaderSize="small"
					/>
				</div>
				<Text className={subCategoryNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<Text className={categoryRowClasses} translationKey={data.category.name} withTooltip={true} />
			<div className={restaurantRowClasses}>
				<RestaurantsList restaurants={restaurants} />
			</div>
			<Text className={customerRowClasses} translationKey={data.customer.name} withTooltip={true} />
			<div className={isHiddenRowClasses}>
				<RestaurantsList restaurants={isHiddenRestaurants} />
			</div>
		</div>
	);
};

export default Item;
